// extracted by mini-css-extract-plugin
export default {"control":"Skills_control__fxv7t","container":"Skills_container__V6PUl","title":"Skills_title__U1xeS","resume":"Skills_resume__pgK+X","icon":"Skills_icon__ZyEqg"};